import JSZip from 'jszip';

export type CreateZipParameters = {
  files: FileData[];
  zipFileName: string;
};

export type FileData = {
  data: ArrayBuffer | Blob | string | Uint8Array;
  fileName: string;
};

export const createZip = async ({ files, zipFileName }: CreateZipParameters) => {
  const zip = new JSZip();
  for (const { data, fileName } of files) {
    zip.file(fileName, data);
  }

  const zipBlob = await zip.generateAsync({ type: 'blob' });

  return {
    zipBlob,
    zipFileName,
  };
};
